import { z } from 'zod'

export const PLACE_CONTACT_REQUEST_TYPES = [
	'GENERAL',
	'PRIVACY',
	'CORRECTION',
	'HISTORY',
	'OWNERSHIP',
	'REMOVAL',
] as const

export type PlaceContactRequestType =
	(typeof PLACE_CONTACT_REQUEST_TYPES)[number]

export const PLACE_CONTACT_REQUEST_STATUSES = [
	'OPEN',
	'IN_REVIEW',
	'RESOLVED',
] as const

export type PlaceContactRequestStatus =
	(typeof PLACE_CONTACT_REQUEST_STATUSES)[number]

export const PlaceContactRequestSchema = z
	.object({
		placeSlug: z.preprocess(
			(value) => (value === '' ? null : value),
			z.string().trim().min(1).nullable().optional(),
		),
		submissionKey: z.string().uuid(),
		placeMediaId: z.string().trim().min(1).nullable().optional(),
		requestType: z.enum(PLACE_CONTACT_REQUEST_TYPES),
		contactEmail: z.string().trim().email().max(320),
		details: z.string().trim().min(10).max(4000),
	})
	.refine((value) => !value.placeMediaId || value.placeSlug, {
		message: 'Media context requires a place.',
		path: ['placeMediaId'],
	})

export function placeContactHref({
	placeSlug,
	requestType,
	mediaId,
}: {
	placeSlug: string
	requestType: PlaceContactRequestType
	mediaId?: string
}) {
	const search = new URLSearchParams({
		place: placeSlug,
		request: requestType,
	})
	if (mediaId) search.set('media', mediaId)
	return `/support?${search}`
}
